import { render, staticRenderFns } from "./CloneProjectRepository.vue?vue&type=template&id=7984f00c&lang=pug&"
import script from "./CloneProjectRepository.vue?vue&type=script&lang=js&"
export * from "./CloneProjectRepository.vue?vue&type=script&lang=js&"
import style0 from "./CloneProjectRepository.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports